import { Reveal } from "../Reveal";

const STATS = [
  { value: "1970", label: "Année de fondation" },
  { value: "500", label: "Licenciés" },
  { value: "4", label: "Pas de tir" },
  { value: "18", label: "Armes en location" },
];

export function Stats() {
  return (
    <section className="px-5 py-20 md:px-8">
      <Reveal>
        <div className="mx-auto grid max-w-7xl gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {STATS.map((s) => (
            <div key={s.label} className="border-t border-line pt-6">
              <p className="font-display text-5xl text-brass md:text-7xl">{s.value}</p>
              <p className="mt-2 text-sm text-mute">{s.label}</p>
            </div>
          ))}
        </div>
      </Reveal>
    </section>
  );
}
